<div class="layout-sidebar">

    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
